var map = {
	"./aws.png": 80,
	"./c++.png": 81,
	"./firebase.png": 82,
	"./flutter.png": 83,
	"./graphql.png": 84,
	"./hasura.png": 85,
	"./html_css_js.png": 86,
	"./logo_test.png": 87,
	"./mysql.png": 88,
	"./php.png": 89,
	"./postgre.png": 90,
	"./python.png": 91,
	"./react.png": 92,
	"./reactjs.png": 93
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;